var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{
    name: 'border',
    params: { zone: _vm.zone, border: _vm.border },
  }}},[_c('h3',{staticClass:"btn btn-lg text-center text-gray-800 text-uppercase font-weight-bold w-100"},[_vm._v("\n    "+_vm._s(_vm.alias)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }